import { z } from 'zod';

export const encounterTypeSchema = z.enum(['IP', 'OP', 'ER', 'PE']);
export type EncounterType = z.infer<typeof encounterTypeSchema>;
